import React from 'react'
import { Col, Row, Button } from 'antd'
import { ApplicationCardListItem, ApplicationCardListItemPlaceholder } from './itemList'

function ApplicationList({ appList, loading, onCreateApp }) {
    return (
        <div className="gx-main-content gx-pb-sm-4">
            <Row justify="center" type="flex">
                <Col xs={18} md={18}>
                    <Row justify="space-between" type="flex" style={{ padding: 30 }}>
                        <Button icon="plus" style={{ margin: 0 }} onClick={onCreateApp}>
                            Create App
                        </Button>
                    </Row>
                </Col>

                <Col xs={24} md={18}>
                    {loading ? (
                        <ApplicationCardListItemPlaceholder />
                    ) : (
                        appList.map((data, index) => <ApplicationCardListItem key={index} data={data} />)
                    )}
                </Col>
            </Row>
        </div>
    )
}

export default ApplicationList
